export default "__VITE_ASSET__e452a9cb__"